/** @file Document hex colours (#rrggbb, #rrggbbaa): split into colour and alpha, join back, validate. */
import { clamp } from '@pose2d/math/clamp';

const HEX6 = /^#[0-9a-fA-F]{6}$/;
const HEX8 = /^#[0-9a-fA-F]{8}$/;

/** Helpers for ColorField; alpha is 0..1 and stored as one byte. */
export const hexColor = {
  /** True when `text` is `#rrggbbaa` (alpha) or `#rrggbb` (no alpha). */
  isValid(text: string, alpha: boolean): boolean {
    return (alpha ? HEX8 : HEX6).test(text);
  },
  /** The `#rrggbb` part, lower case. */
  rgb(hex: string): string {
    return hex.slice(0, 7).toLowerCase();
  },
  /** Alpha 0..1 of `#rrggbbaa`; 1 for `#rrggbb`. */
  alpha(hex: string): number {
    return hex.length === 9 ? parseInt(hex.slice(7, 9), 16) / 255 : 1;
  },
  /** `#rrggbb` plus the rounded alpha byte when `withAlpha`. */
  join(rgb: string, alpha: number, withAlpha: boolean): string {
    if (!withAlpha) return rgb.toLowerCase();
    return `${rgb.toLowerCase()}${Math.round(clamp(alpha, 0, 1) * 255).toString(16).padStart(2, '0')}`;
  },
};
